<template>
  <section class="apple-page apple-auxiliary" :class="'apple-auxiliary-' + kind" :data-apple-auxiliary="kind">
    <component :is="pageComponent" :key="kind" v-bind="$attrs" v-on="$listeners" />
  </section>
</template>
<script>
import AppleNewAlbums from './AppleNewAlbums.vue';
import AppleDailySongs from './AppleDailySongs.vue';
import AppleArtistVideos from './AppleArtistVideos.vue';
import AppleMusicVideo from './AppleMusicVideo.vue';
import AppleQueue from './AppleQueue.vue';
import AppleSharedTrack from './AppleSharedTrack.vue';
import './apple-pages.scss';
import './apple-auxiliary.scss';
import './apple-auxiliary-reference.scss';

// Independent Apple templates retain the original controllers and lifecycle.
// Unavailable catalog APIs keep their real empty/error state.
const pages = Object.fromEntries(Object.entries({
  newAlbum: AppleNewAlbums, dailySongs: AppleDailySongs, next: AppleQueue,
  artistMV: AppleArtistVideos, mv: AppleMusicVideo, sharedTrack: AppleSharedTrack,
}).map(([kind, component]) => [kind, { extends: component, computed: { salt() { return true; } } }]));

export default {
  name: 'AppleAuxiliary', inheritAttrs: false,
  props: { kind: { type: String, required: true } },
  computed: { pageComponent() { return pages[this.kind]; } },
};
</script>
